<!-- Sub-tabs de relatórios -->
<po-tabs>

  <!-- ─── Por Regra ─────────────────────────────────────────────────────── -->
  <po-tab p-label="Por Regra" [p-active]="true" (p-click)="onTabClick('byRule')">

    <!-- Filtros da aba Por Regra -->
    <div class="po-row po-mb-3 po-pt-3">
      <po-datepicker-range
        class="po-sm-12 po-md-4 po-lg-3"
        name="filterByRulePeriod"
        p-label="Período"
        [(ngModel)]="filterByRulePeriod"
      ></po-datepicker-range>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="filterByRuleProjectKey"
        p-label="Projeto"
        [(ngModel)]="filterByRuleProjectKey"
        [p-options]="projectOptions"
      ></po-select>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="filterByRuleSeverity"
        p-label="Severidade"
        [(ngModel)]="filterByRuleSeverity"
        [p-options]="severityOptions"
      ></po-select>

      <div class="po-sm-12 po-md-2 po-lg-5 filter-apply">
        <po-button
          p-label="Aplicar Filtros"
          p-kind="primary"
          p-icon="po-icon-filter"
          (p-click)="applyByRuleFilters()"
        ></po-button>
        <po-button
          p-label="CSV"
          p-kind="secondary"
          p-icon="po-icon-export"
          [p-loading]="exportingByRuleCsv"
          [p-disabled]="ruleRows.length === 0"
          (p-click)="exportByRuleCsv()"
        ></po-button>
      </div>
    </div>

    <po-table
      [p-columns]="ruleColumns"
      [p-items]="ruleRows"
      [p-loading]="loadingByRule"
      [p-sort]="true"
      [p-show-more-disabled]="!hasMoreByRule"
      [p-literals]="{ noData: 'Selecione um período e clique em Aplicar Filtros', showMore: 'Carregar mais' }"
      (p-show-more)="loadMoreByRule()"
    ></po-table>
  </po-tab>

  <!-- ─── Diário ───────────────────────────────────────────────────────── -->
  <po-tab p-label="Diário" (p-click)="onTabClick('daily')">

    <!-- Filtros da aba Diário (sem filtro de Projeto) -->
    <div class="po-row po-mb-3 po-pt-3">
      <po-datepicker-range
        class="po-sm-12 po-md-4 po-lg-3"
        name="filterDailyPeriod"
        p-label="Período"
        [(ngModel)]="filterDailyPeriod"
      ></po-datepicker-range>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="filterDailySeverity"
        p-label="Severidade"
        [(ngModel)]="filterDailySeverity"
        [p-options]="severityOptions"
      ></po-select>

      <div class="po-sm-12 po-md-5 po-lg-7 filter-apply">
        <po-button
          p-label="Aplicar Filtros"
          p-kind="primary"
          p-icon="po-icon-filter"
          (p-click)="applyDailyFilters()"
        ></po-button>
      </div>
    </div>

    <div class="chart-toolbar po-row po-mb-2">
      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="dailyChartType"
        p-label="Tipo de gráfico"
        [(ngModel)]="dailyChartType"
        [p-options]="chartOptionsDailyEvolution"
      ></po-select>

      <div class="po-sm-12 po-md-9 po-lg-10 chart-actions">
        <po-button
          p-label="PNG"
          p-kind="secondary"
          p-icon="po-icon-download"
          [p-loading]="downloadingDailyChart"
          [p-disabled]="dailyRows.length === 0"
          (p-click)="downloadDailyChartPng()"
        ></po-button>
      </div>
    </div>

    <div #dailyChartRef id="reports-daily-chart">
      <po-chart
        *ngIf="showDailyChart"
        p-title="Evolução Diária de Issues"
        [p-type]="dailyChartType"
        [p-series]="dailyChartDisplaySeries"
        [p-categories]="dailyChartDisplayCategories"
        [p-height]="350"
      ></po-chart>
    </div>

    <po-table
      class="po-mt-3"
      [p-columns]="dailyColumns"
      [p-items]="dailyRows"
      [p-loading]="loadingDaily"
      [p-show-more-disabled]="!hasMoreDaily"
      [p-literals]="{ noData: 'Selecione um período e clique em Aplicar Filtros', showMore: 'Carregar mais' }"
      (p-show-more)="loadMoreDaily()"
    ></po-table>
  </po-tab>

  <!-- ─── Consolidado ──────────────────────────────────────────────────── -->
  <po-tab p-label="Consolidado" (p-click)="onTabClick('consolidated')">

    <!-- Filtros da aba Consolidado -->
    <div class="po-row po-mb-3 po-pt-3">
      <po-datepicker-range
        class="po-sm-12 po-md-4 po-lg-3"
        name="filterConsolidatedPeriod"
        p-label="Período"
        [(ngModel)]="filterConsolidatedPeriod"
      ></po-datepicker-range>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="filterConsolidatedProjectKey"
        p-label="Projeto"
        [(ngModel)]="filterConsolidatedProjectKey"
        [p-options]="projectOptions"
      ></po-select>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="filterConsolidatedSeverity"
        p-label="Severidade"
        [(ngModel)]="filterConsolidatedSeverity"
        [p-options]="severityOptions"
      ></po-select>

      <div class="po-sm-12 po-md-2 po-lg-5 filter-apply">
        <po-button
          p-label="Aplicar Filtros"
          p-kind="primary"
          p-icon="po-icon-filter"
          (p-click)="applyConsolidatedFilters()"
        ></po-button>
        <po-button
          p-label="CSV"
          p-kind="secondary"
          p-icon="po-icon-export"
          [p-loading]="exportingConsolidatedCsv"
          [p-disabled]="consolidatedRows.length === 0"
          (p-click)="exportConsolidatedCsv()"
        ></po-button>
      </div>
    </div>

    <po-table
      class="po-mt-3"
      [p-columns]="consolidatedColumns"
      [p-items]="consolidatedRows"
      [p-loading]="loadingConsolidated"
      [p-sort]="true"
      [p-show-more-disabled]="!hasMoreConsolidated"
      [p-literals]="{ noData: 'Nenhum dado consolidado encontrado', showMore: 'Carregar mais' }"
      (p-show-more)="loadMoreConsolidated()"
    ></po-table>
  </po-tab>

</po-tabs>
